/**
 * @export
 * @function
 * @param {Object} data - Slide data
 * @return {string}
 */
export let sliderTextTpl = function(data, index) {

    let copyright = '';
    if (data.copyright && data.signature) {
        copyright = `<p class="slider__desc__copyright"> ${data.copyright} </p>
                     <p class="slider__desc__signature"> ${data.signature} </p>`;
    }
    return `<div class="slider__desc__slide row" data-slider-descindex="${index}">
                <div class="col-12">
                    <p class="slider__desc__pager">
                        <span class='slider__desc__pager-current'>${data.currentSlide}</span> /
                        <span class='slider__desc__pager-total'>${data.totalSlides}</span>
                    </p>
                </div>
                <div class="col-12 col-sm-6 slider__desc__left content-zone">
                    ${data.description || ''}
                </div>
                <div class="col-12 col-sm-4 col-sm-offset-2 slider__desc__right">
                    ${copyright}
                </div>
            </div>`;
};

/**
 * @export
 * @function
 * @param {Object[]} data List of slides data
 * @return {string}
 */
export let sliderTextContainerTpl = function(data) {
    return `<div class="slider__desc js-slider-desc">
                ${data.map((elem, index) => {
                    return sliderTextTpl(elem, index);
                }).join('')}
            </div>`;
};

/**
 * Slide of main slider
 *
 * @export
 * @function
 * @param {string} source src attribute
 * @param {string} srcset srcset attribute
 * @param {string} sizes sizes attribute
 * @param {string} alt alt attribute
 * @return {string}
 */
export let listItemTpl = function(source, srcset, sizes, alt) {
    return `<li class="slider__item js-slider-slide">
                <img class="slider__item-img" src="${source}" srcset="${srcset}" sizes="${sizes}" alt="${alt}"/>
            </li>`;
};

/**
 * Slide of controller slider
 *
 * @export
 * @function
 * @param {string} source src attribute
 * @param {string} alt alt attribute
 * @param {Number} index Index value for the data-slider-controlindex attribute
 * @return {string}
 */
export let listItemControllerTpl = function(source,alt, index) {
    return `<li class="slider__controls__item js-slider-slide" data-slider-controlindex="${index}">
                <img src="${source}" alt="${alt}"/>
            </li>`;
};

/**
 * @export
 * @function
 * @param {Object[]} data Suite of slidesTpl string
 * @return {string}
 */
export let sliderMainTpl = function(data) {
    return `<div class="slider__slider js-slider-slider">
                <div class="slider__frame js-slider-frame">
                    <ul class="slider__slides js-slider-slides">
                        ${data.map((elem) => {
                            return listItemTpl(elem.src, elem.srcset, elem.sizes, elem.alt);
                        }).join('')}
                    </ul>
                </div>
                <button class="js_prev prev">
                    <svg class="ico ico--chevron-left" width="50" height="50"><use xlink:href="#chevron-left"/></svg>
                </button>
                <button class="js_next next">
                    <svg class="ico ico--chevron-right" width="50" height="50"><use xlink:href="#chevron-right"/></svg>
                  </button>
            </div>`;
};

/**
 * @export
 * @function
 * @param {Object[]} data Data of slides
 * @return {string}
 */
export let sliderControllerTpl = function(data) {
    return `<div class="slider__controls js-slider-controls">
                <div class="slider__controls__frame js-slider-frame">
                    <ul class="slider__controls__slides js-slider-slides">
                        ${data.map((elem, index) => {
                            return listItemControllerTpl(elem.src, elem.alt, index);
                        }).join('')}
                    </ul>
                </div>
            </div>`;
};

/**
 * Slider module (main slider and controller)
 *
 * @export
 * @default
 * @function
 * @param {Object[]} data List of slides data
 * @return {string}
 */
let sliderModule = function(data) {
    return `<div class="slider" data-slider-module>
                <div class="slider__wrap">
                    ${sliderMainTpl(data)}
                    ${sliderControllerTpl(data)}
                </div>
                ${sliderTextContainerTpl(data)}
            </div>`;
};

export default sliderModule;




// WEBPACK FOOTER //
// ./src/main/js/templates/sliderTpl.js